import React from 'react';
import { Button, Menu, MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import { Language as LanguageIcon } from '@mui/icons-material';
import { useLanguage } from '../contexts/LanguageContext';
import translations from '../utils/translations';

const LanguageSelector = ({ variant = 'icon' }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { language, setLanguage, t } = useLanguage();
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageSelect = (langCode) => {
    setLanguage({ code: langCode });
    handleClose();
  };

  return (
    <>
      {variant === 'icon' ? (
        <Button
          id="language-button"
          aria-controls={open ? 'language-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          startIcon={<LanguageIcon />}
          sx={{
            minWidth: 'auto',
            px: 1,
            color: 'primary.main',
            '&:hover': {
              backgroundColor: 'rgba(255, 112, 67, 0.08)'
            }
          }}
        >
          {translations[language.code]?.code || language.code}
        </Button>
      ) : (
        <MenuItem onClick={handleClick}>
          <ListItemIcon>
            <LanguageIcon />
          </ListItemIcon>
          <ListItemText>
            {t('menu.language')} ({translations[language.code]?.code || language.code})
          </ListItemText>
        </MenuItem>
      )}
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'language-button',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {Object.keys(translations).map((langCode) => (
          <MenuItem
            key={langCode}
            selected={langCode === language.code}
            onClick={() => handleLanguageSelect(langCode)}
            sx={{
              minWidth: 150,
              py: 1,
            }}
          >
            <ListItemText>
              {translations[langCode].nativeName} ({translations[langCode].name})
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
